import PageHero from '@/components/feature/PageHero';
import { jiuchouPosition } from '@/mocks/jiuchou-architecture';

export default function JiuchouHero() {
  return (
    <PageHero
      eyebrow={jiuchouPosition.eyebrow}
      title={jiuchouPosition.title}
      titleHighlight={jiuchouPosition.subtitle}
      desc={jiuchouPosition.desc}
      imageUrl="https://readdy.ai/api/search-image?query=Abstract%20digital%20commerce%20operating%20system%20visualization%2C%20deep%20dark%20ink%20navy%20background%2C%20glowing%20emerald%20and%20gold%20light%20streams%20connecting%20rural%20county%20nodes%20through%20digital%20shelves%20and%20data%20constellation%2C%20eco%20green%20accent%20lines%2C%20futuristic%20rural%20digital%20economy%20aesthetic%2C%20minimal%20clean%20composition%2C%20cinematic%20lighting%2C%20high%20detail%2C%20harmonious&width=1800&height=1100&seq=jiuchou-arch-02&orientation=landscape"
      imageAlt="九畴云铺 乡村数字经济操作系统"
      imageTitle="九畴云铺 乡村数字经济操作系统"
    />
  );
}